import React, { useRef } from 'react';
import { Chat } from '../../../../chatSlice';
import { formatChatTime } from '../../../utils/timeUtils';

export type ChatListItemProps = {
    chat: Chat;
    active?: boolean;
    onClick?: (chatId: string) => void;
    onDelete?: (chatId: string) => void;
    onLongPress?: (chatId: string) => void;
};

const ChatListItem: React.FC<ChatListItemProps> = ({ chat, active, onClick, onDelete, onLongPress }) => {
    const longPressTimer = useRef<NodeJS.Timeout | null>(null);
    const isLongPress = useRef(false);

    const handleClick = () => {
        if (!isLongPress.current) {
            onClick?.(chat.id);
        }
        isLongPress.current = false;
    };

    const handleDelete = (e: React.MouseEvent) => {
        e.stopPropagation(); // Предотвращаем всплытие события
        onDelete?.(chat.id);
    };

    const handleLongPress = () => {
        onLongPress?.(chat.id);
    };

    const handleMouseDown = () => {
        isLongPress.current = false;
        longPressTimer.current = setTimeout(() => {
            isLongPress.current = true;
            handleLongPress();
        }, 500); // 500ms для долгого тапа
    };

    const handleMouseUp = () => {
        if (longPressTimer.current) {
            clearTimeout(longPressTimer.current);
            longPressTimer.current = null;
        }
    };

    const handleMouseLeave = () => {
        if (longPressTimer.current) {
            clearTimeout(longPressTimer.current);
            longPressTimer.current = null;
        }
    };

    return (
        <div
            className={`chat-item ${active ? 'active' : ''}`}
            onClick={handleClick}
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseLeave}
        >
            <div className='chat-item-content'>
                <div className='chat-item-header'>
                    <p className='chat-item-title'>{chat.title}</p>
                    {chat.isDirty && (
                        <div className='sync-indicator dirty' title="Не синхронизировано">
                            <svg width="8" height="8" viewBox="0 0 24 24" fill="currentColor">
                                <circle cx="12" cy="12" r="10" />
                            </svg>
                        </div>
                    )}
                </div>
                <p className='chat-item-time'>{formatChatTime(chat.lastMessageTime)}</p>
            </div>
            <button
                className='chat-item-delete-btn'
                onClick={handleDelete}
                title="Удалить чат"
            >
                ×
            </button>
        </div>
    );
};

export default ChatListItem; 